module.exports = __webpack_public_path__ + "static/media/load-loans.5b03961a.svg";